import { render } from "./DeliveryDetails.vue?vue&type=template&id=7439eceb&scoped=true"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"

import "./DeliveryDetails.vue?vue&type=style&index=0&id=7439eceb&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7439eceb"]])

export default __exports__